export type ENV = string | undefined;

const isOff = (env: ENV) => env !== 'on';
const isEnable = (env: ENV) => env === 'on';

const FeatureToggleHelper = { isOff, isEnable };

export default FeatureToggleHelper;
